import SeasonType from "./actionTypes"

const INIT_STATE = {
  pageData: {
    loading: true,
    data: {}
  },
  detail: {
    loading: false,
    data: {}
  },
  saved: {
    loading: false
  },
  list: {
    loading: true,
    data: []
  }
}

const Season = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SeasonType.GET_SEASON_PAGES_SUCCESS:
      return {
        ...state,
        pageData: action.payload,
      }

    case SeasonType.GET_DETAIL_SEASON_BY_ID_SUCCESS:
      return {
        ...state,
        detail: action.payload,
      }

    case SeasonType.PUT_SEASON_SUCCESS:
      return {
        ...state,
        saved: action.payload,
      }

    case SeasonType.POST_SEASON_SUCCESS:
      return {
        ...state,
        saved: action.payload,
      }

    case SeasonType.GET_SEASON_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload,
      }

    default:
      return state
  }
}

export default Season
